// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"e89379a2","345":"6db18ebb","420":"0a5830f5","478":"1f2d7eb9","495":"bab2c14b","536":"46b5afb3"}[chunkId] + ".chunk.css";
};